module.exports = __webpack_public_path__ + "img/Arrow_Down.d44bb3b1.svg";